import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useCategoryStore = create((set) => ({
  categoryLoading: false,
  totalCategories: 0,

  categories: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },

  // Function to reset currentPage only when an action happens
  resetCurrentPage: () => {
    set((state) => ({
      pagination: {
        ...state.pagination,
        currentPage: 1,
      },
    }));
  },

  // Function to get categories
  getCategory: async ({ query = null, successCallback }) => {
    set({ categoryLoading: true });
    useLoadingStore.getState().setLoading(true);

    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_CATEGORIES,
        null,
        query
      );

      if (response.success) {
        set((state) => ({
          totalCategories: response.data?.pagination?.totalCategories || 0,
          categories: response.data?.data || [],
          pagination: {
            ...state.pagination, // Ensure existing pagination properties are preserved
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalPages,
          },
        }));

        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      set({
        categoryLoading: false,
      });
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to create the categories
  createCategory: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.CREATE_CATEGORY,
        data
      );

      if (response.success) {
        await useCategoryStore.getState().getCategory({
          query: {
            page: 1,
            limit: 10,
            type: 'compliance',
          },
          successCallback: () => {
            useCategoryStore.getState().resetCurrentPage();
            successCallback && successCallback(response);
          },
        });
      }
    } catch (error) {
      console.error('Error creating category:', error);
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete categories
  deleteCategory: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.DELETE,
        API_ENDPOINTS.DELETE_CATEGORY,
        null,
        null,
        id
      );

      if (response.success) {
        set((state) => {
          const updatedCategories = state.categories.filter(
            (category) => category.id !== id
          );

          const updatedTotalItems = updatedCategories.length;
          const updatedTotalPages = Math.ceil(
            updatedTotalItems / state.pagination.pageSize
          );

          return {
            categories: updatedCategories,
            pagination: {
              ...state.pagination,
              totalItems: updatedTotalItems,
              totalPages: updatedTotalPages,
            },
          };
        });
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update categories
  updateCategory: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CATEGORY,
        data,
        null,
        id
      );

      if (response.success) {
        await useCategoryStore.getState().getCategory({
          successCallback: () => {
            useCategoryStore.getState().resetCurrentPage(); // Reset page
            successCallback && successCallback(response);
          },
        });
      }

      // if (response.success) {
      //   set((state) => {
      //     // Find the updated category
      //     const updatedCategory = state.categories.find(
      //       (category) => category.id === id
      //     );

      //     // If the category is found, update it and move it to the first position
      //     if (updatedCategory) {
      //       const updatedCategories = [
      //         { ...updatedCategory, ...data }, // Updated category
      //         ...state.categories.filter((category) => category.id !== id), // Rest of the categories
      //       ];

      //       return {
      //         categories: updatedCategories,
      //         pagination: {
      //           ...state.pagination,
      //           currentPage: 1,
      //         },
      //       };
      //     }

      //     // If the category is not found, return the state as is
      //     return state;
      //   });

      //   successCallback && successCallback(response);
      // }
    } catch (error) {
      // Handle error
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to active/inactive category
  toggleCategoryStatus: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.ACTIVE_INACTIVE_CATEGORY,
        data,
        null,
        id
      );
      if (response.success) {
        set((state) => ({
          categories: state.categories.map((category) =>
            category.id === id ? { ...category, ...data } : category
          ),
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useCategoryStore;
